<template>
    <div>
        <navbar1></navbar1>
        <div class="__buildbg"></div>
        <!-- <div class="container-fluid p-0">
            <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-4 p-0">
                    <div class="__ourproimg">
                        <p class="__join">Join over 4000+</p>
                        <p class="__ourproduct1">Designers<br>Sign up</p>
                        <p class="__ourproduct2">Continue here <img src="../assets/img/right-arrow-top-white.svg"> </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 p-0">
                    <div class="__ourproimg1">
                        <p class="__join">Manage products</p>
                        <p class="__ourproduct1">Project managers<br>Sign up</p>
                        <p class="__ourproduct2">Continue here <img src="../assets/img/right-arrow-top-white.svg"> </p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 p-0">
                    <a href="http://pro.findworka.com" target="blank"><div class="__ourproimg2"></div></a>
                    <div class="__ourproimg2">
                        <p class="__join">Join over 6000k devs</p>
                        <p class="__ourproduct1">Developers<br>Sign up</p>
                        <p class="__ourproduct2">Continue here <img src="../assets/img/right-arrow-top-white.svg"> </p>
                    </div>
                </div>
            </div>
        </div> -->

        <div class="container">
            <div class="__form-wrap ">
                <div class="row ">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <p class="__number">
                        10,000+
                        </p>
                        <p>
                        Number of professionals in <br />
                        our PRO network.
                        </p>

                        <p class="__number">
                        500+
                        </p>
                        <p>
                        Number of hired developers <br />
                        and designers.
                        </p>

                        <p class="__number">
                        280+
                        </p>
                        <p>
                        Number of clients<br />
                        we work with.
                        </p>
                    </div>
                    <div class="col-lg-8 col-md-8 col-sm-8">
                        <p class="__hirep">
                        Let us know you
                        </p>

                        <p class="__hirep1">We charge 10% of the talent’s annual salary only.</p>
                        <!-- <p class="__hirep1">We charge N30,000 i.e $83 as commitment fee and 10% of the talent’s annual salary.</p> -->

                        <form @submit.prevent="processForm()" method="POST" enctype="multipart/form-data">
                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="full-name">Full name</label>

                                        <input
                                        autofocus
                                        type="text"
                                        class="form-control __form-control"
                                        id="full-name"
                                        name="full-name"
                                        data-field="general"
										v-model="formField.fullName"
                                        placeholder="John Jane Doe"
										required="required"
                                        />
                                    </div>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="email">Email</label>

                                        <input
                                        type="email"
                                        class="form-control __form-control"
                                        id="email"
                                        name="email"
                                        data-field="email"
										v-model="formField.email"
                                        placeholder="address@yourdomain.com"
										required="required"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="phone">Phone number</label>
                                        <input
                                        type="tel"
                                        class="form-control __form-control"
                                        id="phone"
                                        name="phone"
                                        data-field="phone"
										v-model="formField.phoneNumber"
                                        placeholder="+234 810 544 8756"
										required="required"
                                        />
                                    </div>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-6">
									<div class="form-group">
                                        <label for="company-loc">Company location</label>
										<select v-model="formField.companyLocation" name="location" id="location" class="form-control __form-control" required="required">
											<option value="location" disabled>Location</option>
											<option value="on-site">On-site</option>
											<option value="remote">Remote</option>
										</select>
									</div>
                                    
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
										<label for="salary-range">Talent (UI/UX, project-manager e.t.c)</label>
										<input type="text" v-model="formField.talent" name="talent" placeholder=" " class="form-control __form-control" required>
									</div>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="day-amt">Days per week</label>

                                        <select
                                        class="form-control __form-control"
                                        id="day-amt"
                                        name="day-amt"
                                        data-field="general"
										v-model="formField.daysPerWeek"
                                        >
                                            <option value="">Enter Days per week</option>
                                            <option value="1">1 day</option>
                                            <option value="2">2 day</option>
                                            <option value="3">3 day</option>
                                            <option value="4">4 day</option>
                                            <option value="5">5 day</option>
                                            <option value="6">6 day</option>
                                            <option value="7">7 day</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            
							
							<div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
                                        <label for="work-dur">Week Duration</label>

                                        <input
                                        type="number"
                                        class="form-control __form-control"
                                        id="work-dur"
                                        name="work-dur"
                                        data-field="general"
										v-model="formField.weekDuration"
                                        placeholder="Enter duration"
										required="required"
                                        />
                                    </div>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
										<label for="salary-range">Duration</label>
										<select 
                                        v-model="formField.duration" name="durationLabel" id="" class="form-control __form-control" required="required">
											<option value="duration" disabled>Duration</option>
											<option value="weeks">Weeks</option>
											<option value="months">Months</option>
										</select>
									</div>
                                </div>
                            </div>
							
							
							<div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
										<label for="salary-range">Job (Job description)</label>
										<input type="text" v-model="formField.jobDescription" name="job" placeholder=" " class="form-control __form-control" required>
									</div>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <div class="form-group">
										<label for="salary-range">Job location </label>
										<textarea v-model="formField.jobLocation" name="joblocate" id="job-location" class="form-control __form-control" rows="3" placeholder="Job location (city where the job is at)" required="required"></textarea>
									</div>
                                </div>
                            </div>
							

                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                <div class="form-group">
                                    <label for="salary-range">Salary range</label>

                                    <input
                                    type="text"
                                    class="form-control __form-control"
                                    id="salary-range"
                                    name="salary-range"
                                    data-field="general"
                                    placeholder="N 000,000.00"
									v-model="formField.salaryRange"
									required
                                    />
                                </div>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-6">
                                <div class="form-group">
                                    <label for="resumption"
                                    >Resumption (When do you want the talent to resume)</label
                                    >

                                    <input
                                    type="date"
                                    class="form-control __form-control"
                                    id="resumption"
                                    name="resumption"
                                    data-field="general"
                                    placeholder="Enter Date"
									v-model="formField.resumptionDate"
									required
                                    />
                                </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-6">
									<div class="form-group">
										<label for="work-time">Part time or full time</label>

										<div class="__radio-wrap">
											<div class="radio">
												<label class="cust-label no-top">
												<input
													data-radio="work-time"                         
													type="radio"
													name="type"
													value="part-time"
													v-model="formField.jobType"
												/>Part time
												<span class="checkmark"></span>
												</label>
											</div>
											<div class="radio">
												<label class="cust-label">
												<input
													type="radio"
													name="type"
													value="full-time"
													v-model="formField.jobType"
												/>Full time
												<span class="checkmark"></span>
												</label>
											</div>
											<!-- <div class="radio">
												<label class="cust-label">
												<input
													type="radio"
													name="work-time"
													value="on-site"
												/>On site
												<span class="checkmark"></span>
												</label>
											</div>
											<div class="radio">
												<label class="cust-label">
												<input
													type="radio"
													name="work-time"
													value="remote"
												/>Remote On
												<span class="checkmark"></span>
												</label>
											</div> -->

											<div class="radio">
												<label class="cust-label">
												<input
												
													type="radio"
													name="type"
													value="onsite-remote"
                                                    v-model="formField.jobType"
												/>On site with remote options
												<span class="checkmark"></span>
												</label>
											</div>
										</div>
									</div>
                                </div>

                                <div class="col-lg-6 col-md-6 col-sm-6">
									<div class="form-group">
										<label for="work-time">Levels</label>

										<div class="__radio-wrap">
											<div class="radio">
												<label class="cust-label no-top">
												<input
													data-radio="level"
													type="radio"
													name="level"
													value="beginner"
													v-model="formField.jobLevel"
												/>Beginner
												<span class="checkmark"></span>
												</label>
											</div>

											<div class="radio">
												<label class="cust-label">
												<input
													type="radio"
													name="level"
													value="intermediate"
													v-model="formField.jobLevel"
												/>Intermediate
												<span class="checkmark"></span>
												</label>
											</div>

											<div class="radio">
												<label class="cust-label">
												<input

													type="radio"
													name="level"
													value="expert"
													v-model="formField.jobLevel"
												/>Senior
												<span class="checkmark"></span>
												</label>
											</div>
										</div>
									</div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-sm-6">
                                <button class="btn btn-block  __adjustlink ">Submit form</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="__wedobg">
            <div class="container">
                <p class="__wedop">Why become our Pro?</p>
                <p class="__wedop1">By becoming a Findworka Pro, you get premium access to the best software design and development projects.</p>
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <img src="../assets/img/quality-control.png" class="__hidimg">
                        <p class="__hidep">Premium Projects</p>
                        <p class="__hidep1">We are very choosy about the kind of projects we manage. The typical Findworka project is at the intersection of being mission critical, the need for great tech, an ambitious client and a decent budget.</p>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <img src="../assets/img/best.png" class="__hidimg">
                        <p class="__hidep">Work with Best</p>
                        <p class="__hidep1">We strive to be the best and take our time to sign up the best programming talents in Africa. This means that if you are an a-lister, you'll collaborate with your type everytime we execute together.</p>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4">
                        <img src="../assets/img/money.png" class="__hidimg">
                        <p class="__hidep">Make Money</p>
                        <p class="__hidep1">Of Course! We offer very competitive rates to our talents. Whether you work on a 2 week project, a 3-month contract or even get signed up for full-time work with our clients, you'll be doing great work for ambitious people and making money.</p>
                    </div>
                    <!-- <div class="col-lg-3 col-md-3 col-sm-6">
                        <i class="__icon fas fa-palette"></i>
                        <p class="__hidep">Start Executing</p>
                        <p class="__hidep1">Focus on building the Nth version of your products by hiring from our network of PRO talents. </p>
                    </div> -->
                </div>
            </div>
        </div><br><br>

        <div class="container">
            <p class="__hirep">Not yet a Pro?</p>

            <p class="__hirep1">You shouldn't worry. We understand that to become an expert, you need to<br> keep practicing, learning, sharing and collaborating. That is why we have<br> Findworka Academy and the Saucecode community to help you grow.</p>
        <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="__proimgcard">

                        <p class="__procp">Start your tech career by joining our tech academy</p>
                        <a href="https://jointechcampus.com/" target="_blank" class="btn __procpbtn">Join techcampus</a>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="__proimgcard1">
                        <p class="__procp">Join campus alpha<br> or participate in our events</p>

                        <a href="mailto:admin@findworka.com" target="blank" class="btn __procpbtn1">Join Saucecode</a>
                        <!-- <a href="http://saucecode.xyz/hackathon/alpha" target="blank" class="btn __procpbtn1">Join Saucecode</a>
                        <a style="cursor:pointer" target="blank" class="btn __procpbtn1">Join Saucecode</a> -->
                    </div>
                </div>
            </div>
        </div><br><br>
    </div>
</template>

<script>
import navbar1 from '../components/navbar1';

import axios from 'axios'
export default {
    components: { navbar1,},
    data () {
        return{
            formField: {
                fullName: null,
                email: null,
                phoneNumber: null,
                jobType: 'select',
                companyLocation: 'location',
                weekDuration: null,
                duration: 'duration',
                talent: null,
                jobDescription: null,
                jobLocation: null,
                daysPerWeek: null,
                salaryRange: null,
                resumptionDate: null,
                jobLevel: 'level',
            },
            redirect: true   
        }
    },
  
 methods: {
        uploadFile(event){
            this.file = event.target.files[0]
        },
            processForm: function() {
                this.$validator.validateAll().then(() => {
                    if (! this.errors.any()) {
                        // Make the api call for form submission
                        this.makeFormRequest()
                    } else {
                        // Show form validation error toast
                        this.$toasted.global.form_validation_error()
                    }
                });
            },
            makeFormRequest: function () {
                let fd = {
                    fullName:this.formField.fullName,
                    email:this.formField.email,
                    phoneNumber:this.formField.phoneNumber,
                    companyLocation:this.formField.companyLocation,
                    talent:this.formField.talent,
                    daysPerWeek:this.formField.daysPerWeek,
                    weekDuration:this.formField.weekDuration,
                    duration:this.formField.duration,
                    jobDescription:this.formField.jobDescription,
                    jobLocation:this.formField.jobLocation,
                    salaryRange:this.formField.salaryRange,
                    resumptionDate:this.formField.resumptionDate,
                    jobType:this.formField.jobType,
                    jobLevel:this.formField.jobLevel,
                };
                axios({
                    url:'https://findworka-api.onrender.com/api/v1/forms/pro',
                    headers: {"Access-Control-Allow-Origin": "*", "api_key":"qfoudwCWJkPatcztt%bIxcuoMBEGK9tdv2%jz4Jt4y5CYpc2KAUkQXBfdJ0EeqRh5F!MyvyTO7VSdCoWfPd52RpEpB2arBJGVPtR03wXayBrKdWPFS3AdM0LswwGXQHmkMLwGvwJmcEjiOeZhQ2pxLcHaC3DU87B5Wvc8b5629f78a2d03a42cfde3a52c69tyeyhfj"},
                    'Content-Type': 'application/json' ,
                    method: 'post',
                    
                    data: fd
                    })
                    .then((response) => {
                        console.log(response)
                        if (response.data.error == true) {
                            // Should redirect to list if redirect was checked
                            this.$toasted.show(response.data.message[0])
                        }else {
                            this.$toasted.show(response.data.message)
							this.$router.push({ name: 'payment' })
							// window.location.href = "http://siwei.me"
                        }
                            //Reset form
                    })
                    .catch(error => this.apiErrorCatcher(error))
                    .finally( () => this.resetForm())//clear form automatically after successful request
            },
            resetForm() {
                console.log('Reseting the form')
                var self = this; //you need this because *this* will refer to Object.keys below`

                //Iterate through each object field, key is name of the object field`
                Object.keys(this.formField).forEach(function(key,index) {
                self.formField[key] = '';
                });
		    }
    }
}


</script>

<style scoped>
@import '../assets/css/pro';
</style>


// WEBPACK FOOTER //
// src/components/pro.vue